<script>
import PromoExtraMonthsBenefit from './promo-extra-months-benefit.vue';
import PromoHoliday from './promo-holiday';
import PromoIncentive from './promo-incentive';
import PromoReferral from './promo-referral.vue';
import PromoReactivation from './promo-reactivation.vue';


export default {
  functional: true,

  inject: ['hasHolidayPromo', 'hasReferralCode', 'hasExtraMonthsBenefit', 'hasReactivationPromo'],

  render(h, ctx) {
    if (ctx.injections.hasReactivationPromo()) {
      return <PromoReactivation />;
    }
    const showExtraMonthsBenefit = ctx.injections.hasExtraMonthsBenefit();
    if (showExtraMonthsBenefit) {
      if (ctx.parent.$route.path === '/pricing/') {
        return <PromoExtraMonthsBenefit />;
      }
      return null;
    }
    if (ctx.injections.hasReferralCode()) {
      return <PromoReferral />;
    }
    if (ctx.injections.hasHolidayPromo) {
      return <PromoHoliday />;
    }

    return (<PromoIncentive/>);
  },
};
</script>
